module.exports = __webpack_public_path__ + "img/certificate-2.75f18cb1.jpg";